/*
Ashraf 11/28/2022 2698948956 added search repo fields table
Ashraf 11/28/2022 2698948956 added mandatory field
Poornima 11/30/2022 2698948956 fixed prepopulate bugs
Ashraf 12/01/2022 2698948956 added error tooltip
Ashraf 12/01/2022 2698948956 fixed column spaces
Ashraf 12/01/2022 2698948956 selecting either of mandatory or view only
Ashraf 12/01/2022 2698948956 added created by abd date to columns
Ashraf 12/03/2022 2698948956 restricted adding duplicate names
Sai Maheshwar 12/04/2022 2698948956 Added map fields save close buttons
Ashraf 12/04/2022 2698948956 fixed prepopulation issue
Ashraf 12/04/2022 2698948956 selected checkboxes disabling issue
Dilip 12/05/2022 2698948956 removed unnecessary console.log statements
Lalitha 12/22/2022 2698948956 Rearrange Repository Description
Raghu 12/22/2022 269894895 Table footer stylings
Sai maheshwar 03/20/2023  4136387705 added multirecord selection validation in custom window
suresh peddavoora 02/24/2023 269894895 New UI changes
suresh peddavoora 03/15/2023 269894895 responsive fields alignment fixes
Sohel  05/05/2023 4136387705 Added Mandatory and View only Popup
Akhila 06/08/2023 4136387705 created date change to date created field and column
Sohel 02/10/2023 4136387705 custom Window Payload Changes
Sohel 03/10/2023 5155351299 Search Payload Changes
Sohel 07/10/2023 5155351299 checkbox issue fixed
Sohel 10/10/2023 2805568664 Add field based on repository name and field name
Sohel 10/25/2023 2805568664 Fixed Mandatory and View Only Validation Toast issue
*/

import React, { createRef, useEffect, useState } from 'react';
import {
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TablePagination,
  TextField,
} from '@material-ui/core';
import { tableIcons } from '../../../components/TableIcons';
import { httpPaginationPost } from '../../../util/Rest';
import { useDispatch } from 'react-redux';
import { defaultRows } from '../../../constants/ReusableTablePagination';
import { makeStyles } from '@material-ui/core';
import { tablePageRows } from '../../../constants/ReusableConstants';
import GuiTable from '../../../components/FormComponents/GuiTable';
import { ErrorTooltip } from '../../Tooltips';
import moment from 'moment';
import ConsecutiveSnackbars from './AlertPopup';
const useStyles = makeStyles((theme) => ({
  searchText: {
    fontWeight: '900',
    color: '#000000',
    fontSize: '16px',
    marginBottom: '0',
  },
}));
const fieldUsage = ['IMPORT', 'TRIGGER', 'WORK_QUEUE', 'REPORT', 'EXPORT'];
function AddFieldListTable({
  searchData,
  baseValue,
  selectedRows,
  setSelectedRows,
  submit,
  setSubmit,
  tempSelectedRows,
  setTempSelectedRows,
  tempUnCheckedRef,
}) {
  const companyData = JSON.parse(sessionStorage.getItem('companyName'));
  companyData?.unshift('ALL');
  const columns = [
    {
      title: 'Category',
      field: 'category',
      maxWidth: 90,
      render: (rowData) => {
        return rowData?.category === 'CL'
          ? 'CL - Client'
          : rowData?.category === 'CO'
            ? 'CO - Core'
            : rowData?.category === 'PA'
              ? 'PA - Payment'
              : '';
      },
    },
    {
      title: 'Repository Name',
      field: 'repositoryName',
      cellStyle: {
        maxWidth: 250,
        minWidth: 250,
      },
      render: (rowData) => (
        <div className="table-word-wrap">{rowData?.repositoryName?.replace(/ /g, '\u00a0')}</div>
      ),
    },
    {
      title: 'Repository Description',
      field: 'repositoryDescription',
      cellStyle: {
        maxWidth: 250,
        minWidth: 250,
      },
      render: (rowData) => (
        <>
          <div className="table-word-wrap">
            {rowData?.repositoryDescription?.replace(/ /g, '\u00a0')}{' '}
          </div>
        </>
      ),
    },
    {
      title: 'Field Name',
      field: 'fieldName',
      cellStyle: {
        maxWidth: 250,
        minWidth: 250,
      },
      render: (rowData) => (
        <>
          <div className="table-word-wrap">{rowData?.fieldName?.replace(/ /g, '\u00a0')} </div>
        </>
      ),
    },
    {
      title: 'Field Description',
      field: 'fieldDescription',
      cellStyle: {
        maxWidth: 250,
        minWidth: 250,
      },
      render: (rowData) => (
        <>
          <div className="table-word-wrap">
            {rowData?.fieldDescription?.replace(/ /g, '\u00a0')}{' '}
          </div>
        </>
      ),
    },

    {
      title: 'Field Type',
      field: 'fieldType',
      maxWidth: '85px',
    },
    {
      title: 'Created By',
      field: 'createdBy',
      maxWidth: 100,
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      maxWidth: 90,
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Company',
      field: 'company',
      maxWidth: 90,
      render: (rowData) => {
        return rowData?.company ? rowData?.company : '';
      },
    },
  ];

  const [countTotal, setCountTotal] = useState('');
  const classes = useStyles();
  const tableRef = createRef();
  const dispatch = useDispatch();
  // const [arrayLast, setArrayLast] = useState(false);
  const arrayLast = false;
  const [rows, setRows] = useState(defaultRows);
  const [selectedNames, setSelectedNames] = useState();

  useEffect(() => {
    const selected = [];
    selectedRows &&
      selectedRows?.map((i) => {
        selected.push(i?.fieldName);
      });
    setSelectedNames(selected);
  }, [selectedRows]);

  useEffect(() => {
    if (setTempSelectedRows) {
      setTempSelectedRows([]);
      tempUnCheckedRef.current = [];
    }
  }, []);

  // based on search data and submit update table(2700807425)
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit, searchData]);

  return (
    // Changed Table header and body color (2700807425)
    <>
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table new-standard-textfields tablescroll-block">
          <GuiTable
            title={
              <div>
                <p className={classes.searchText}>
                  We found {`"${countTotal}"`} {countTotal === 1 ? 'result' : 'results'}
                </p>
              </div>
            }
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-repository/search/data-repository-field`;
                const bodyObj = {
                  category: searchData?.category?.categoryCode
                    ? searchData.category?.categoryCode
                    : '',
                  fieldName: searchData?.fieldName ? searchData.fieldName : '',
                  fieldDescription: searchData?.fieldDescription ? searchData.fieldDescription : '',
                  repositoryName: searchData?.repoName ? searchData.repoName : '',
                  repositoryDescription: searchData?.repoDescription
                    ? searchData.repoDescription
                    : '',
                  fieldType: searchData?.fieldType ? searchData?.fieldType : '',
                  companyList: searchData?.company?.length > 0 ? searchData?.company : companyData,
                  fieldUsage: fieldUsage,
                  createdBy: searchData?.createdBy?.userLoginName
                    ? searchData?.createdBy?.userLoginName
                    : '',
                  createdDate: searchData?.createdDate
                    ? moment(searchData?.createdDate).format('MM/DD/YYYY')
                    : '',

                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  page: submit
                    ? 1
                    : arrayLast && query.page >= 1
                      ? query.page
                      : arrayLast
                        ? (query.page <= 1 && query.page + 1) || query.page - 1
                        : query.page + 1,
                };

                if (query && query.search.length) {
                  bodyObj.search = query.search;
                }

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const newObj = {};
                        [...selectedRows, ...tempSelectedRows].forEach((el) => {
                          if (!newObj[el.repositoryName + el.fieldName]) {
                            newObj[el.repositoryName + el.fieldName] = el;
                          }
                        });
                        const newRows = response.data.response.resultObject.map((elem) => {
                          if (newObj[elem.repositoryName + elem.fieldName]) {
                            return { ...elem, tableData: { ...elem.tableData, checked: true } };
                          } else {
                            return {
                              ...elem,
                              tableData: { ...elem.tableData, checked: false },
                            };
                          }
                        });
                        resolve({
                          data: newRows.length > 0 ? newRows : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setCountTotal(response.data.response.count);
                        // setArrayLast(response.data.response.resultObject.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              selection: true,
              toolbar: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              // selectionProps: (rowData) => ({
              //   disabled: (() => {
              //     const currentSelectedData = [...selectedRows, ...tempSelectedRows].filter(
              //       (el) => el.multiRecord === "Y"
              //     );
              //     const existingMultiRecordFieldName = currentSelectedData[0]?.repositoryName;
              //     const newFieldName = rowData.multiRecord === "Y" ? rowData?.repositoryName : null;
              //     if (
              //       newFieldName &&
              //       existingMultiRecordFieldName &&
              //       existingMultiRecordFieldName !== newFieldName
              //     ) {
              //       console.log("truee");
              //       return true;
              //     }
              //     return (
              //       selectedNames?.includes(rowData?.fieldName) && !rowData?.tableData?.checked
              //     );
              //   })(),
              //   //   selectedNames?.includes(rowData?.fieldName) && !rowData?.tableData?.checked,
              //   // color: "primary",
              // }),
              selectionProps: (rowData) => {
                const currentSelectedData = [...selectedRows, ...tempSelectedRows].filter(
                  (el) => el.multiRecord === 'Y',
                );
                return {
                  disabled: Boolean(
                    currentSelectedData?.length > 0 &&
                      currentSelectedData[0]?.repositoryName !== rowData.repositoryName &&
                      rowData?.multiRecord === 'Y',
                  ),
                };
              },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                setTempSelectedRows([
                  ...tempSelectedRows,
                  {
                    ...row,
                    tableData: { ...row.tableData, id: row.globalField },
                    ...getFields({ ...row, fieldCode: row?.repositoryType }),
                    repository: row?.globalField,
                  },
                  // let fH = formValues["fieldHeader" + r.fieldName] ||  r.fieldLabel;
                  // let mF = formValues["mandatoryField" + r.fieldName]  || r?.isMandatory;
                  // let vF = formValues["viewOnlyField" + r.fieldName]  || r?.viewOnly;
                ]);
                const sel = [...selectedNames, row?.fieldName];
                setSelectedNames(sel);
              } else {
                tempUnCheckedRef.current.push(row);
                const updatedRows = [...tempSelectedRows]
                  .filter((ele) => {
                    return (
                      ele?.repositoryName + ele?.fieldName !== row?.repositoryName + row?.fieldName
                    );
                  })
                  .map((ele) => {
                    return { ...ele, tableData: { ...ele.tableData, id: ele.globalField } };
                  });
                const sel = selectedRows?.filter((i) => {
                  return i?.repositoryName + i?.fieldName !== row?.repositoryName + row?.fieldName;
                });
                setSelectedNames(sel);
                setTempSelectedRows(updatedRows);
              }
            }}
            components={{
              Pagination: (props) => (
                <div className="pagination-disable global-field-table-footer">
                  <TablePagination
                    {...props}
                    // fixed rows per screen label (2700807425)
                    SelectProps={{
                      inputProps: { 'aria-label': 'Rows per screen' },
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}

export const getFields = (unSelected) => {
  return {
    fieldHeader: ({ values, handleChange, touched, errors, inputFieldValues, setFieldValue }) => {
      return (
        <>
          <div key={unSelected?.repositoryName + unSelected?.fieldName} className="format-field">
            <ErrorTooltip
              title={
                errors['fieldHeader' + unSelected?.repositoryName + unSelected?.fieldName]
                  ? errors['fieldHeader' + unSelected?.repositoryName + unSelected?.fieldName]
                  : ''
              }
            >
              <TextField
                margin="dense"
                type="text"
                variant="outlined"
                placeholder={`Enter Field Label`}
                InputLabelProps={{
                  shrink: true,
                }}
                required
                name={'fieldHeader' + unSelected?.repositoryName + unSelected?.fieldName}
                value={values['fieldHeader' + unSelected?.repositoryName + unSelected?.fieldName]}
                onChange={(e) => {
                  setFieldValue(
                    'fieldHeader' + unSelected?.repositoryName + unSelected?.fieldName,
                    e.target.value,
                  );
                  inputFieldValues[
                    'fieldHeader' + unSelected?.repositoryName + unSelected?.fieldName
                  ] = e.target.value;
                }}
                error={
                  touched['fieldHeader' + unSelected?.repositoryName + unSelected?.fieldName] &&
                  errors['fieldHeader' + unSelected?.repositoryName + unSelected?.fieldName]
                }
              />
            </ErrorTooltip>
          </div>
        </>
      );
    },
    viewOnlyTextField: ({
      values = {},
      touched = {},
      errors = {},
      inputFieldValues,
      setFieldValue,
      disabled = false,
      setFieldTouched = () => {},
      isSubmitting = false,
    }) => {
      return (
        <>
          <div key={unSelected?.repositoryName + unSelected?.fieldName} className="format-field">
            <FormControl margin="dense" variant="outlined" fullWidth>
              <Select
                name={'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName}
                className="select-gender custom-window-select-fields"
                disabled={values?.viewOnly}
                // disabled={inputFieldValues["viewOnlyField" + unSelected?.repositoryName + unSelected?.fieldName] === "Y" || unSelected?.viewOnly === "Y"}
                value={
                  values?.viewOnly
                    ? 'Y'
                    : values[
                      'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName
                    ] || 'none'
                }
                onChange={(e) => {
                  setFieldValue(
                    'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName,
                    e.target.value,
                  );
                  inputFieldValues[
                    'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName
                  ] = e.target.value;
                  if (
                    e.target.value === 'Y' &&
                    values[
                      'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName
                    ] === 'Y'
                  ) {
                    setFieldValue(
                      'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName,
                      'N',
                    );
                    setFieldTouched(
                      'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName,
                      true,
                    );
                    inputFieldValues[
                      'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName
                    ] = 'N';
                  } else {
                    setFieldTouched(
                      'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName,
                      false,
                    );
                    setFieldValue(
                      'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName,

                      inputFieldValues[
                        'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName
                      ],
                    );
                    inputFieldValues[
                      'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName
                    ] =
                      inputFieldValues[
                        'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName
                      ];
                  }
                }}
              >
                <MenuItem value="none" key="none" disabled>
                  <span className="defaultSelected"> Select Any</span>
                </MenuItem>
                <MenuItem value={'Y'} key={'Y'}>
                  Y
                </MenuItem>
                <MenuItem value={'N'} key={'N'}>
                  N
                </MenuItem>
              </Select>
            </FormControl>
            <FormHelperText>
              {touched['viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName] &&
                errors['viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName] &&
                errors['viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName]}
            </FormHelperText>
            {!isSubmitting &&
            touched['mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName] &&
            values['mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName] ===
              'Y' ? (
                <ConsecutiveSnackbars
                  touched={touched}
                  setFieldTouched={setFieldTouched}
                  name={'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName}
                  message={"setting the field mandatory, the other can't be view only"}
                />
              ) : null}
          </div>
        </>
      );
    },
    mandatory: ({
      values = {},
      touched = {},
      errors = {},
      inputFieldValues,
      setFieldValue,
      disabled = false,
      setFieldTouched = () => {},
      isSubmitting = false,
    }) => {
      return (
        <>
          <div key={unSelected?.repositoryName + unSelected?.fieldName} className="format-field">
            <FormControl margin="dense" variant="outlined" fullWidth>
              <Select
                name={'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName}
                className="select-gender custom-window-select-fields"
                disabled={values?.viewOnly}
                // disabled={inputFieldValues["mandatoryField" + unSelected?.repositoryName + unSelected?.fieldName] === "Y" || unSelected?.isMandatory === "Y"}
                value={
                  values?.viewOnly
                    ? 'N'
                    : values[
                      'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName
                    ] || 'none'
                }
                onChange={(e) => {
                  setFieldValue(
                    'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName,
                    e.target.value,
                  );
                  inputFieldValues[
                    'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName
                  ] = e.target.value;
                  if (
                    e.target.value === 'Y' &&
                    values['viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName] ===
                      'Y'
                  ) {
                    setFieldValue(
                      'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName,
                      'N',
                    );
                    inputFieldValues[
                      'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName
                    ] = 'N';
                    setFieldTouched(
                      'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName,
                      true,
                    );
                  } else {
                    setFieldValue(
                      'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName,

                      inputFieldValues[
                        'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName
                      ],
                    );
                    inputFieldValues[
                      'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName
                    ] =
                      inputFieldValues[
                        'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName
                      ];
                    setFieldTouched(
                      'mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName,
                      false,
                    );
                  }
                }}
              >
                <MenuItem value="none" key="none" disabled>
                  <span className="defaultSelected"> Select Any</span>
                </MenuItem>
                <MenuItem value={'Y'} key={'Y'}>
                  Y
                </MenuItem>
                <MenuItem value={'N'} key={'N'}>
                  N
                </MenuItem>
              </Select>
            </FormControl>
            <FormHelperText>
              {touched['mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName] &&
                errors['mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName] &&
                errors['mandatoryField' + unSelected?.repositoryName + unSelected?.fieldName]}
            </FormHelperText>

            {!isSubmitting &&
            touched['viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName] &&
            values['viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName] === 'Y' ? (
                <ConsecutiveSnackbars
                  touched={touched}
                  setFieldTouched={setFieldTouched}
                  name={'viewOnlyField' + unSelected?.repositoryName + unSelected?.fieldName}
                  message={"setting the field View Only, the other can't be Mandatory"}
                />
              ) : null}
          </div>
        </>
      );
    },
  };
};
export default React.memo(AddFieldListTable);
